module.exports = __webpack_public_path__ + "static/media/cafe_nordoy.03bc80b2.webp";